import DynamicForm, { FormValuesOutput } from '@policygenius/mortar-dynamic-forms';
import { useCreateDataPointValues, useGetDataPointValues } from 'api/hooks/useDataPointValues';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { completedNavigatorStep } from 'analytics/navigator';
import { StepName } from 'analytics/navigator/constants';
import DynamicFormWrapper from 'components/DynamicFormWrapper';
import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { CONTINUE_ONLINE_CITIZENSHIP_PATH } from 'routes/constants';
import useSelector from 'store/useSelector';

import schema from './schema';
import { FormValues } from './types';

const INTERVIEW_URNS: Array<keyof FormValues> = [
  'urn:pg:data-point:insured-military-service',
  'urn:pg:data-point:insured-military-current-station',
  'urn:pg:data-point:insured-military-dates-or-service',
  'urn:pg:data-point:insured-military-branch',
  'urn:pg:data-point:insured-military-pay-grade',
  'urn:pg:data-point:insured-military-rank',
  'urn:pg:data-point:insured-military-duties',
  'urn:pg:data-point:insured-military-mobilization-category',
  'urn:pg:data-point:insured-military-foreign-assignments',
];

const MilitaryService: React.FC = () => {
  const navigate = useNavigate();
  const activeUserUuid = useSelector((app) => app.activeUserUuid);

  const { data, loading } = useGetDataPointValues({
    params: {
      urns: INTERVIEW_URNS,
    },
  });
  const { createDataPointValuesFromInterview } = useCreateDataPointValues({
    onCompleted: () => {
      completedNavigatorStep(StepName.MILITARY_SERVICE, activeUserUuid);

      navigate(`../${CONTINUE_ONLINE_CITIZENSHIP_PATH}`);
    },
  });

  if (loading) {
    return <GlobalLoader />;
  }

  const onSubmit = async (values: FormValuesOutput<FormValues>) => {
    await createDataPointValuesFromInterview(values, schema);
  };

  return (
    <NavigatorContent>
      <DynamicFormWrapper>
        <DynamicForm<FormValues>
          name="military-service"
          initialValues={data?.dataPointValues}
          schema={schema}
          onSubmit={onSubmit}
        />
      </DynamicFormWrapper>
    </NavigatorContent>
  );
};

export default MilitaryService;
